<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-11">
          <h1 class="title green">{{ $translate(materialtext) | capitalize }} - {{ title }}</h1>
        </div>
        <div class="column has-text-right">
          <button
            v-if="id !== 0 && id !== -1 && id != null"
            type="button"
            class="button is-danger"
            @click="deleteOccurence(id)"
          >
            <b-icon icon="delete-outline" />
          </button>

          <button type="button" class="button is-primary" @click="validateBeforeSubmit">
            <b-icon icon="content-save-outline" />
          </button>
        </div>
      </div>
      <hr />

      <b-field v-if="id !== -1" horizontal :label="$translate('id_material') | capitalize">
        <b-input v-if="id !== -1" v-model="id" name="id_material" disabled="true" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('CUI') | capitalize"
        :message="errors.first('CUI')"
        :type="{ 'is-danger': errors.has('CUI') }"
      >
        <b-input v-model="material.CUI" v-validate="'required|unique'" name="CUI" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('commercial_name') | capitalize"
        :message="errors.first('commercial_name')"
        :type="{ 'is-danger': errors.has('commercial_name') }"
      >
        <b-input v-model="material.commercial_name" v-validate="'required'" name="commercial_name" />
      </b-field>
      <b-field horizontal :label="$translate('thickness') | capitalize">
        <b-input v-model="material.thickness" name="thickness" />
      </b-field>
      <b-field horizontal :label="$translate('hardness') | capitalize">
        <b-input v-model="material.hardness" name="hardness" />
      </b-field>
      <b-field
        v-if="materialtext === 'Ins_I'"
        horizontal
        :label="$translate('insertFilter') | capitalize"
        :message="errors.first('insertFilter')"
        :type="{ 'is-danger': errors.has('insertFilter') }"
      >
        <b-select v-model="material.insertFilter" v-validate="'required'" name="insertFilter">
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in insertFilterOptions" :key="option" :value="option">
            {{ $translate(option) | capitalize }}
          </option>
        </b-select>
      </b-field>
      <b-field horizontal>
        <b-button type="is-primary" icon-left="plus" @click="addTag()" />
      </b-field>
      <template v-for="(item, index) in optional_tag">
        <b-field :key="index" horizontal :label="$translate('optional_tag') | capitalize">
          <b-input v-model="item.key" :name="index" />
          <b-button type="is-danger" icon-left="minus" @click="removeTag(index)" />
        </b-field>

        <b-field v-if="item.imageAlreadyUploaded" :key="index + 'image'" horizontal>
          <table>
            <tr>
              <img :src="item.image" width="100px" height="auto" />
            </tr>
            <tr>
              <b-button type="is-danger" icon-left="delete-outline" @click="removeImageTag(index)">
                {{ $translate('remove_image') | capitalize }}
              </b-button>
            </tr>
          </table>
        </b-field>

        <b-field
          v-else
          :key="index + 'image'"
          class="file"
          :label="$translate('image') | capitalize"
          :message="errors.first('image')"
          :type="{ 'is-danger': errors.has('image') }"
          horizontal
        >
          <b-upload v-model="item.image" name="image">
            <a class="button is-primary">
              <b-icon icon="upload" />
              <span>{{ $translate('upload_button') }}</span>
            </a>
            <span v-if="item.image" class="file-name">
              {{ item.image.name }}
            </span>
          </b-upload>
        </b-field>
      </template>
      <template>
        <b-field v-if="hasVariants" horizontal>
          <b-button type="is-primary" icon-left="plus" @click="addVariant">
            {{ $translate('add_variant') | capitalize }}
          </b-button>
        </b-field>
        <hr class="green" />
        <div style="margin-top: 20px">
          <div v-for="variant in variants" :key="variant.id">
            <template v-if="hasVariants">
              <b-field v-if="variant.id != -1" horizontal :label="$translate('id_variant') | capitalize">
                <b-input v-if="variant.id != -1" v-model="variant.id" name="id_variant" disabled="true" />
              </b-field>
              <b-field
                horizontal
                :label="$translate('CUIV') | capitalize"
                :message="errors.first('CUIV')"
                :type="{ 'is-danger': errors.has('CUIV') }"
              >
                <b-input v-model="variant.CUIV" v-validate="'required'" name="CUIV" />
              </b-field>
              <b-field
                horizontal
                :label="$translate('name') | capitalize"
                :message="errors.first('name')"
                :type="{ 'is-danger': errors.has('name') }"
              >
                <b-input v-model="variant.name" v-validate="'required'" name="name" />
              </b-field>
              <b-field horizontal :label="$translate('CUI_optionalbool') | capitalize">
                <b-switch v-model="variant.CUI_optionalbool" />
              </b-field>
              <b-field
                v-if="variant.CUI_optionalbool"
                horizontal
                :label="$translate('CUI_optional') | capitalize"
                :message="errors.first('CUI_optional')"
                :type="{ 'is-danger': errors.has('CUI_optional') }"
              >
                <b-input v-model="variant.CUI_optional" v-validate="'required'" name="CUI_optional" />
              </b-field>
            </template>
            <b-field v-if="variant.imageAlreadyUploaded" horizontal>
              <table>
                <tr>
                  <img :src="variant.image" width="100px" height="auto" />
                </tr>
                <tr>
                  <b-button type="is-danger" icon-left="delete-outline" @click="removeImage(variant.id - 1)">
                    {{ $translate('remove_image') | capitalize }}
                  </b-button>
                </tr>
              </table>
            </b-field>
            <b-field
              v-else
              class="file"
              :label="$translate('image') | capitalize"
              :message="errors.first('image')"
              :type="{ 'is-danger': errors.has('image') }"
              horizontal
            >
              <b-upload v-model="variant.file" v-validate="'required'" name="image">
                <a class="button is-primary">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
                <span v-if="variant.file" class="file-name">
                  {{ variant.file.name }}
                </span>
              </b-upload>
            </b-field>
            <br />
            <div v-if="hasVariants">
              <b-field horizontal>
                <b-button type="is-danger" icon-left="minus" @click="removeVariant(variant.id - 1)">
                  {{ $translate('remove_variant') | capitalize }}
                </b-button>
              </b-field>
              <hr class="green" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import permissionMixin from '@/helpers/mixins/permissionMixin'
//import { storage } from 'firebase';

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'MaterialForm',
  mixins: [permissionMixin],
  props: ['module'],
  data() {
    return {
      id: 0,
      title: '',
      uploadValue: 0,
      variants: [],
      optional_tag: [],
      isSaveDisabled: false,
      hasVariants: true,
      insertFilterOptions: ['avampiede', 'mesopiede', 'retropiede', 'piani_inclinati'],
      material: {
        CUI: '',
        commercial_name: '',
        thickness: 0,
        hardness: 0,
        insertFilter: '',
        optional_tag: [],
        variants: [],
      },
    }
  },
  created() {
    this.materialtext = this.$route.params.material
    const moduleMaterialsWithoutVariants = this.$moduleConfiguration[this.module].materials.noVariants
    this.id = this.$route.params.id

    this.hasVariants = !moduleMaterialsWithoutVariants.includes(this.materialtext)
  },
  mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') isAllowed = true
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')
    if (this.$route.params.material === undefined || this.$route.params.id === undefined) {
      this.$router.push('/forbidden')
    }

    this.title = this.id === -1 ? this.$translate('new_material') : this.$translate('modify_material')

    if (this.id !== -1) {
      this.loadDataToEdit()
    } else {
      if (this.$route.params.idtocopy !== undefined) {
        this.loadDataToCopy()
      } else {
        this.addVariant()
      }
    }

    this.$validator.extend('unique', async value => {
      let counter = 0
      await this.$db
        .collection(this.materialtext)
        .where('CUI', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              counter++
            }
          })
        })

      return counter <= 0
    })
  },
  methods: {
    addTag() {
      this.optional_tag.push({
        key: '',
        imageAlreadyUploaded: false,
        toRemoveoldImage: false,
        image: {},
      })
    },
    removeTag(index) {
      this.optional_tag.splice(index, 1)
    },
    removeImageTag(index) {
      this.optional_tag[index].imageAlreadyUploaded = false
      this.optional_tag[index].toRemoveoldImage = true
      this.optional_tag[index].image = ''
      this.$forceUpdate()
    },
    addVariant() {
      this.variants.push({
        id: this.variants.length + 1,
        imageAlreadyUploaded: false,
        toRemoveoldImage: false,
        name: '',
        quantity: 0,
        CUI_optionalbool: false,
        CUI_optional: '',
      })
    },
    removeVariant(index) {
      if (this.variants.length > 1) {
        this.variants.splice(index, 1)
        for (let i = 0; i < this.variants.length; i++) {
          this.variants[i].id = i + 1
        }
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('at_least_one_variant'),
        })
      }
    },
    removeImage(index) {
      this.variants[index].imageAlreadyUploaded = false
      this.variants[index].toRemoveoldImage = true
      this.$forceUpdate()
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          this.send()
          return
        }
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },

    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('material_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('material_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection(this.materialtext)
            .doc(idtoerase)
            .delete()
            .then(async () => {
              if (this.hasVariants) {
                for (const key in this.variants) {
                  if (this.variants[key].imageAlreadyUploaded) {
                    let desertRef = this.$storage.ref(
                      'materials/variants/' + this.materialtext + '/' + this.id + '/' + key + '/key'
                    )
                    await desertRef
                      .delete()
                      .then(function() {})
                      .catch(function() {}) //error) {
                    //console.log(error);
                    //});
                  }
                }
              }
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
              await this.$router.push({ name: 'materials' })
            }),
      })
    },

    async send() {
      this.isSaveDisabled = true
      if (this.id === -1) {
        this.material.registeredAt = new Date().getTime()
        let materialRef = await this.$db.collection(this.materialtext).add(this.material)
        this.id = materialRef.id
      }
      for (const variant of this.variants) {
        const key = variant.id - 1
        const { imageAlreadyUploaded, toRemoveoldImage, ...variantInfo } = variant
        this.material.variants[key] = variantInfo
        if (!variant.imageAlreadyUploaded) {
          let storageRef = this.$storage.ref(`materials/variants/${this.materialtext}/${this.id}/${key}/key`)
          if (variant.toRemoveoldImage) await storageRef.delete()
          let snapshot = await storageRef.put(this.variants[key].file)
          let url = await snapshot.ref.getDownloadURL()
          this.material.variants[key].image = url
          // Hotfix - Firebase non supporta più il salvataggio di chiave contenenti oggi File Custom
          delete this.material.variants[key].file
        }
      }
      let i = 0
      for (const tag of this.optional_tag) {
        let newTag = tag
        if (!this.optional_tag[i].imageAlreadyUploaded && Object.keys(this.optional_tag[i].image).length) {
          let storageRef = this.$storage.ref(`materials/optional_tag/${this.materialtext}/${this.id}/${i}/key`)
          if (tag.toRemoveoldImage) await storageRef.delete()
          if (tag.image) {
            let snapshot = await storageRef.put(tag.image)
            let url = await snapshot.ref.getDownloadURL()
            newTag.image = url
            newTag.imageAlreadyUploaded = true
          } else {
            newTag.image = ''
            newTag.imageAlreadyUploaded = false
          }
        }
        newTag.toRemoveoldImage = false
        this.material.optional_tag[i] = newTag
        i++
      }
      //console.log(this.material)
      await this.$db
        .collection(this.materialtext)
        .doc(this.id)
        .update(this.material)
      this.isSaveDisabled = false
      this.$router.push({ name: 'materials' })
    },

    loadDataToEdit() {
      this.$db
        .collection(this.materialtext)
        .doc(this.id)
        .get()
        .then(doc => {
          this.material = doc.data()
          if (this.material.optional_tag === '') {
            this.material.optional_tag = []
          }
          if (this.material.insertFilter === undefined) {
            this.$set(this.material, 'insertFilter', '')
          }
          this.variants = this.material.variants
          for (const key in this.variants) {
            this.variants[key].imageAlreadyUploaded = true
            this.variants[key].toRemoveoldImage = false
            if (this.variants[key].CUI_optionalbool === undefined) {
              this.variants[key].CUI_optionalbool = false
              this.variants[key].CUI_optional = ''
            }
          }
          this.optional_tag = this.material.optional_tag

          for (const key in this.optional_tag) {
            if (this.optional_tag[key].image === undefined) {
              this.optional_tag[key].image = ''
            }
          }

          this.material.variants = []
          this.material.optional_tag = []
        })
    },
    loadDataToCopy() {
      this.$db
        .collection(this.$route.params.materialtocopy)
        .doc(this.$route.params.idtocopy)
        .get()
        .then(doc => {
          this.material = doc.data()
          if (this.hasVariants) {
            this.variants = this.material.variants
            for (const key in this.variants) {
              this.variants[key].imageAlreadyUploaded = false
              this.variants[key].toRemoveoldImage = false
              this.variants[key].image = null
            }
          } else {
            this.variants = []
            this.addVariant()
          }
          this.optional_tag = this.material.optional_tag
          for (const key in this.optional_tag) {
            this.optional_tag[key].imageAlreadyUploaded = false
            this.optional_tag[key].toRemoveoldImage = false
            /*            this.optional_tag[key].image = null*/
          }
          this.material.variants = []
          this.material.optional_tag = []
        })
    },
  },
}
</script>
